<template>
  <span ref="snackbarRef" class="snackbar"></span>
</template>

<script setup lang="ts">
import type { ISnackbarData } from '~~/types/local_types';

const { $listen } = useNuxtApp();

const snackbarRef = ref<HTMLSpanElement>();

const showSnackBar = (text: string) => {
  if (snackbarRef.value) {
    snackbarRef.value.innerHTML = text;
    snackbarRef.value.classList.add('show');
    setTimeout(() => {
      snackbarRef.value?.classList.remove('show');
    }, 2000);
  }
};

onMounted(() => {
  $listen('snackbar:show', (data: ISnackbarData) => {
    showSnackBar(data?.message as string);
  });
});
</script>

<style scoped lang="postcss">
.snackbar {
  @mixin heading-xs {
  }
  color: hsl(var(--color-neutral-white));
  background: var(--effect-gradient-btn-primary);
  box-shadow: var(--effect-box-shadow-primary);
  border-radius: var(--unit-4);
  padding: var(--unit-8) var(--unit-16);
  text-align: center;
  left: 50%;
  bottom: 0;
  opacity: 0;
  position: fixed;

  transform: translateX(-50%);
  transform-origin: bottom center;

  transition:
    opacity 250ms linear,
    bottom 325ms ease;
  pointer-events: none;
  z-index: var(--snackbar-z);

  &.show {
    bottom: var(--unit-32);
    transform: translateX(-50%);
    opacity: 1;
  }
}
</style>
